import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';

const SavedReportModal = ({ show, closeModal, saveReportName }) => {
  const [reportName, setReportName] = useState('');

  const savingDisabled = !reportName.trim();

  const submitForm = (event) => {
    event.preventDefault();
    if (savingDisabled) return;

    saveReportName(reportName);
    setReportName('');
    closeModal();
  };

  return (
    <Modal show={show} onHide={closeModal}>
      <form onSubmit={submitForm}>
        <Modal.Header closeButton>
          <Modal.Title>Save As</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-1">Report Name</label>
          <input
            className="form-control"
            name="report-name"
            placeholder="Enter report name"
            type="text"
            value={reportName}
            onChange={e => setReportName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button label="Close" name="close-report" type="button" variant="ghost" onClick={closeModal} />
          <Button disabled={savingDisabled} label="Save" name="save-report" type="submit" />
        </Modal.Footer>
      </form>
    </Modal>
  );
};

SavedReportModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  saveReportName: PropTypes.func.isRequired,
  selectedFilterValues: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired
};

export default SavedReportModal;
